module.exports = __webpack_public_path__ + "static/media/SourceSansPro-ExtraLightIt.cc15f1c2.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-ExtraLightIt.eot
// module id = 83
// module chunks = 3